import React, { useState } from "react";
import { useHistory } from "react-router-dom";
import { Link as ReactRouterLink } from "react-router-dom";
import { Box, Button, Card, CardContent, Typography, Tooltip, Link } from "@common-ui/ui";
import { AddCircle } from "@mui/icons-material";
import { DeleteForever } from "@mui/icons-material";
import { DataGridPro, LicenseInfo, GridToolbar } from "@mui/x-data-grid-pro";
import SummarizeIcon from '@mui/icons-material/Summarize';
import { StatusChip } from "./StatusChip";

LicenseInfo.setLicenseKey(process.env.REACT_APP_DATA_GRID_LICENSE);

export const WorkEventsTableView = (props) => {
  const [pageSize, setPageSize] = useState(props?.rowSize);
  let router = useHistory();
  const columns = [
    {
      field: "id",
      headerName: "Work Event",
      flex: 1,
      renderCell: (params) => {
        return (
          <Link
            component={ReactRouterLink}
            to={`/work-events/${params.row.creating_org}/work-event/${params.row.id}`}
          >
            {params.value ? params.value : "---"}
          </Link>
        );
      },
    },
    {
      field: "customerName",
      headerName: "Client",
      flex: 1,
      renderCell: (params) => {
        return (
          params.row?.for_org?.screen_name ||
          params.row?.for_org?.name ||
          params.row?.for_customer?.screen_name ||
          params.row?.for_customer?.name ||
          "---"
        );
      },
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      renderCell: (params) => {
        return params.value ? <StatusChip status={params.value} /> : "---";
      },
    },
    {
      field: "scheduled_start_date",
      headerName: "Start Date",
      flex: 1,
      renderCell: (params) => {
        return params.value
          ? new Date(params.value).toLocaleDateString()
          : "---";
      },
    },
    {
      field: "scheduled_end_date",
      headerName: "End Date",
      flex: 1,
      renderCell: (params) => {
        return params.value
          ? new Date(params.value).toLocaleDateString()
          : "---";
      },
    },
    {
      field: "work_items",
      headerName: "Work Items",
      flex: 1,
      renderCell: (params) => {
        return params.row.work_item_last_value
          ? params.row.work_item_last_value
          : 0;
      },
    },
    {
      field: "create_date",
      headerName: "Actions",
      flex: 1,
      headerAlign: "center",
      align: "center",
      renderCell: (params) => {
        return (
          <Box sx={{ display: "flex" }}>
            <Tooltip title="Summary Report">
              <div>
                <SummarizeIcon
                  size="small"
                  disabled={params?.row.work_item_last_value === 0}
                  onClick={() =>
                    router.push({
                      pathname: `/work-events/${params.row.for_org}/work-event/${params.row.id}/download`,
                    })
                  }
                />
              </div>
            </Tooltip>
            <Tooltip title="Remove Work Event">
              <div>
                <DeleteForever
                  sx={{ marginLeft: "1rem" }}
                  size="small"
                  disabled={params?.row?.work_item_last_value > 0}
                  onClick={() => {
                    props.setCurrentOrgId(params.row.for_org);
                    props.setCurrentWorkEventId(params.row.id);
                    props.setOpenRemoveDialog(true);
                  }}
                />
              </div>
            </Tooltip>
          </Box>
        );
      },
    },
  ];
  return (
    <>
      <Card>
        {props?.isShowTableHeader && (
          <CardContent sx={{
            display: "flex",
            justifyContent: "space-between",
            padding: ".5rem 1rem",
            alignItems: "center"
          }}>
            <Typography variant="h5" component="div">
              Work: ({props.rowsData?.length})
            </Typography>
            {<Button
              size="medium"
              variant="text"
              startIcon={<AddCircle />}
              sx={{ ml: 2, color: (theme) => theme.palette.grey[700] }}
            >
              Create Work Event
            </Button>}
          </CardContent>
        )}
        <DataGridPro
          getRowId={(row) => row.id}
          sx={dataGrid}
          loading={props.isLoading}
          rows={props.rowsData}
          density="standard"
          pageSize={pageSize}
          rowsPerPageOptions={[5, 10, 25, 50, 100]}
          onPageSizeChange={(newPageSize) => setPageSize(newPageSize)}
          columns={columns}
          pagination
          components={{ Toolbar: GridToolbar }}
          disableSelectionOnClick
          autoHeight={true}
        />
      </Card>
    </>
  );
};

const dataGrid = {
  ".MuiDataGrid-main": {
    background: "#FFFFFF",
  },
  ".MuiDataGrid-columnSeparator": {
    display: "none",
  },
  ".MuiDataGrid-columnHeaders": {
    background: "#F8F8F8",
    border: "1px solid #EBEBEB",
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "49px",
    color: "#333333",
  },
  ".MuiDataGrid-columnHeaderTitle": {
    fontWeight: 700,
  },
  ".MuiDataGrid-row": {
    color: "#333",
    background: "#FFFFFF",
  },
  ".MuiDataGrid-row:hover": {
    cursor: "pointer",
    background: "rgba(43, 124, 211, 0.2)",
    transition: "100ms",
  },
  ".MuiSvgIcon-root": {
    color: "#B3B3B3",
  },
  ".MuiTypography-root": {
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "49px",
    color: "#333333",
  },
};

WorkEventsTableView.defaultProps = {
  rowSize: 25,
  isShowTableHeader: true
}